import React from "react";
import "../../assets/styles/spinner.css";
import Lottie from "lottie-react";
import spinner from "./spinner.json";

const Spinner = () => {
  return (
    <div className="row">
      <div className="col-md-12 my-auto">
        <div className="spinner-loading">
          <Lottie
            animationData={spinner}
            loop={true}
            style={{ width: "25%", height: "25%" }}
          />
          <h6>Page Loading</h6>
          <p>Please wait. It will take sometime to load the data.</p>
        </div>
      </div>
    </div>
  );
};

export default Spinner;
